/* eslint-disable @typescript-eslint/camelcase */

import { MUSIC, CONNECTOR, SILENCE, MOOD_CHILL, MOOD_POWER } from 'constants/audio';
import { Music } from 'types';

// sounds use model defined in ../sound-model
// all durations are in seconds
// duration must be passed if there will be fade in or out
// volume is percent value 0-100
const TRACKS: { [name: string]: Partial<Music> } = {
  LA_001: {
    type: MUSIC,
    url: 'LA_001',
    mood: MOOD_POWER,
    silenceAfter: 10,
    prevents: ['LA_001_loop'],
  },
  LA_002: {
    type: MUSIC,
    url: 'LA_002',
    mood: MOOD_POWER,
    silenceAfter: 10,
    prevents: ['LA_002_loop'],
  },
  LA_003: {
    type: MUSIC,
    url: 'LA_003',
    mood: MOOD_POWER,
    silenceAfter: 15,
    prevents: ['LA_003_loop'],
  },
  LA_FS_3_4: {
    type: MUSIC,
    url: 'LA_FS_3_4',
    mood: MOOD_POWER,
    silenceAfter: 10,
    prevents: ['LA_FS_3_4_loop'],
  },
  LA_004: {
    type: MUSIC,
    url: 'LA_004_Loop',
    loop: true,
    mood: MOOD_CHILL,
    duration: 320,
    volume: 70,
    silenceAfter: 6,
    fadeIn: 4,
    fadeOut: 4,
  },
  LA_005: {
    type: MUSIC,
    url: 'LA_005_Loop',
    loop: true,
    mood: MOOD_CHILL,
    duration: 246,
    volume: 70,
    silenceAfter: 20,
    fadeIn: 4,
    fadeOut: 4,
  },
  LA_006: {
    type: MUSIC,
    url: 'LA_006_Loop',
    loop: true,
    mood: MOOD_POWER,
    duration: 180,
    silenceAfter: 6,
    fadeIn: 2,
    fadeOut: 2,
  },
  LA_FS_001: {
    type: MUSIC,
    url: 'LA_FS_001_Loop',
    loop: true,
    mood: MOOD_CHILL,
    duration: 200,
    volume: 70,
    silenceAfter: 10,
    fadeIn: 4,
    fadeOut: 4,
  },
  LA_FS_0032: {
    type: MUSIC,
    url: 'LA_FS_0032_Loop',
    loop: true,
    mood: MOOD_CHILL,
    duration: 60,
  },
  LA_001_loop: {
    type: CONNECTOR,
    url: 'LA_001_Loop',
    loop: true,
    mood: MOOD_CHILL,
    duration: 50,
    volume: 50,
    silenceAfter: 6,
    fadeIn: 6,
    fadeOut: 6,
    prevents: ['LA_001'],
  },
  LA_002_loop: {
    type: CONNECTOR,
    url: 'LA_002_Loop',
    loop: true,
    mood: MOOD_CHILL,
    duration: 100,
    volume: 50,
    silenceAfter: 15,
    fadeIn: 3,
    fadeOut: 6,
    prevents: ['LA_002'],
  },
  LA_003_loop: {
    type: CONNECTOR,
    url: 'LA_003_Loop',
    loop: true,
    mood: MOOD_CHILL,
    duration: 90,
    volume: 50,
    silenceAfter: 10,
    fadeIn: 2,
    fadeOut: 5,
    prevents: ['LA_003'],
  },
  LA_FS_3_4_loop: {
    type: CONNECTOR,
    url: 'LA_FS_3_4_Loop',
    loop: true,
    mood: MOOD_CHILL,
    duration: 64,
    volume: 50,
    silenceAfter: 10,
    fadeIn: 3,
    fadeOut: 6,
    prevents: ['LS_FS_3_4'],
  },


  [SILENCE]: {
    type: CONNECTOR,
    buffer: [] as any,
    duration: 20,
  },
};

export default TRACKS;
